export default class Workspace {
  constructor(client) {
    this.client = client;
    this.resourceUrl = "";
  }
  getWorkspaceClob(policyKey, healthPlanKey, policyCategory, policyTaskStatus) {
    return this.client.get(`/workspace/getWorkspaceWithClob`, {
      params: { policyKey, healthPlanKey, policyCategory, policyTaskStatus },
    });
  }

  transformClob(workspaceKey) {
    return this.client.post(
      `/workspace/clob-transformation?workspaceKey=${workspaceKey}`
    );
  }
  updateWorkSpceClob(
    workspace,
    submit,
    policyHistoryData,
    ctReviewData,
    updateAssignessReviewerDto,
    policyChangeControlXrefDto
  ) {
    return this.client.put(
      `/workspace/updateWorkspaceWithClob?workspaceKey=${workspace.workspaceKey}&submit=${submit}`,
      {
        workspace,
        policyHistoryData,
        ctReviewData,
        updateAssignessReviewerDto,
        policyChangeControlXrefDto,
      }
    );
  }
}
